if(navigator.userAgent.indexOf("Chrome-Lighthouse") == -1) {      

    var msiModal = new tingle.modal({
    closeLabel: 'Cerrar',
    onClose: function() {
        console.log('close');
    },
    onOpen: function() {
        console.log('open');
    },
    beforeOpen: function() {
        console.log('before open');
    },
    beforeClose: function() {
        console.log('before close');
        return true;
    },
    cssClass: ['o-msi-table', 'class2']
    
    });
    var btn = document.querySelector('.o-product-header__msi--link');
    btn.addEventListener('click', function(){
        msiModal.open();
    });
    msiModal.setContent(document.querySelector('.o-msi-modal').innerHTML);



    var shippingModal = new tingle.modal({
    closeLabel: 'Cerrar',
    onClose: function() {
        console.log('close');
    },
    onOpen: function() {
        console.log('open');
    },
    beforeOpen: function() {
        console.log('before open');
    },
    beforeClose: function() {
        console.log('before close');
        return true;
    },
    cssClass: ['o-size-table', 'class2']
    
    });
    var btn = document.querySelector('.o-return-policy__copy');
    btn.addEventListener('click', function(){
        shippingModal.open();
    });
    shippingModal.setContent(document.querySelector('.o-shipping-modal').innerHTML);



    var shippingModalD = new tingle.modal({
        closeLabel: 'Cerrar',
        onClose: function() {
            console.log('close');
        },
        onOpen: function() {
            console.log('open');
        },
        beforeOpen: function() {
            console.log('before open');
        },
        beforeClose: function() {
            console.log('before close');
            return true;
        },
        cssClass: ['o-size-table', 'class2']
    });

    var btnDelivery = document.querySelector('.o-delivery-btn');
    btnDelivery.addEventListener('click', function(){
        shippingModalD.open();
    });
    shippingModalD.setContent(document.querySelector('.o-shipping-modal').innerHTML);




    var sizeModal = new tingle.modal({
        closeLabel: 'Cerrar',
        onClose: function() {
            console.log('close');
        },
        onOpen: function() {
            console.log('open');
        },
        beforeOpen: function() {
            console.log('before open');
        },
        beforeClose: function() {
            console.log('before close');
            return true;
        },
        cssClass: ['o-size-table', 'class2']
    });

    var btn = document.querySelector('.o-product__label-size-help');
    btn.addEventListener('click', function(){
        sizeModal.open();
    });
    sizeModal.setContent(document.querySelector('.o-size-modal').innerHTML);

    var sizeModalTest = new tingle.modal({
        closeLabel: 'Cerrar',
        onClose: function() {
            console.log('close');
        },
        onOpen: function() {
            console.log('open');
        },
        beforeOpen: function() {
            console.log('before open');
        },
        beforeClose: function() {
            console.log('before close');
            return true;
        },
        cssClass: ['o-size-table', 'class2-test']
    });

    var btnTest = document.querySelector('.o-product__label-size-help-test');
    btnTest.addEventListener('click', function(){
        sizeModalTest.open();
    });
    sizeModalTest.setContent(document.querySelector('.o-size-modal-test').innerHTML);
}